import React, { useState } from "react";
import { postApi } from "../../../api/getUser";
import { Col, Container, Row } from "react-bootstrap";
import { FormContainer } from "../../../shared/components/form/FormElements";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import FormHeader from "../../../shared/components/form/FormHeader";
import { Card, CardBody } from "@/shared/components/Card";
import { colorStatusActive } from "../../../utils/palette";
import InfoPopup from "../../../shared/components/InfoPopup";
import { setWoTimerMode } from "../../../features/user/userSlice";
import TimerModeCards from "../../../shared/components/form/TimerModeCards";

const WorkOrderSettings = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { handleSubmit } = useForm();

  const woTimerMode = useSelector((state) => state.user.woTimerMode);
  const roleId = useSelector((state) => state.user.roleId);
  const isReadOnly = roleId !== 1;

  // woTimerMode 0 is a sentinel ("not yet configured") — default the UI to Timer Mode (1)
  const [selected, setSelected] = useState(woTimerMode === 0 ? 1 : woTimerMode);
  const [saveBtnLoading, setSaveBtnLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const onSubmit = async () => {
    setSaveBtnLoading(true);
    const res = await postApi(
      { querystring: "update_wo_timer_mode", wo_timer_mode: selected },
      "commonNew"
    );
    if (res.success) {
      dispatch(setWoTimerMode(selected));
      setShowSuccessPopup(true);
    }
    setSaveBtnLoading(false);
  };

  return (
    <>
      {showSuccessPopup && (
        <InfoPopup
          showPopup={showSuccessPopup}
          setShowPopup={setShowSuccessPopup}
          message={t("work_order_settings_save_success_msg")}
          icon={{ className: "fi fi-rs-check-circle", color: colorStatusActive }}
        />
      )}
      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <FormHeader
          isSaveLoading={saveBtnLoading}
          title={t("work_order_settings")}
          hideSaveButton={isReadOnly}
        />
        <Container>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <h4>{t("time_tracking")}</h4>
                  <p style={{ color: "#666", marginBottom: 20 }}>
                    {t("time_tracking_desc")}
                  </p>
                  <TimerModeCards selected={selected} onChange={setSelected} readOnly={isReadOnly} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </FormContainer>
    </>
  );
};

export default WorkOrderSettings;
